import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { GoogleAnalytics } from '@ionic-native/google-analytics';

import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { Camera } from '@ionic-native/camera';

import { IonicImageViewerModule } from 'ionic-img-viewer';
import { SocialSharing } from '@ionic-native/social-sharing';

import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import { SignupPage } from '../pages/signup/signup';
import { ConfirmPage } from '../pages/confirm/confirm';
import { ForgotPwPage } from '../pages/forgotpw/forgotpw';
import { SettingsPage } from '../pages/settings/settings';
import { AboutPage } from '../pages/about/about';
import { AccountPage } from '../pages/account/account';
import { TabsPage } from '../pages/tabs/tabs';
import { TasksPage } from '../pages/tasks/tasks';
import { TasksCreatePage } from '../pages/tasks-create/tasks-create';
import { HomePage } from '../pages/home/home';
import { CategoryPage } from '../pages/category/category';
import { PostPicPage } from '../pages/post-pic/post-pic';
import { CommentViewPage } from '../pages/comments-view/comments-view';
import { VoteBankPage } from '../pages/vote-bank/vote-bank';
import { LeaderBoardPage } from '../pages/leaderboard/leaderboard';
import { ChangePwPage } from '../pages/change-pw/change-pw';
import { UserPostPage } from '../pages/user-posts/user-posts';
import { PostFeedbackPage } from '../pages/post-feedback/post-feedback';
import { TermsOfServicePage } from '../pages/terms-of-service/terms-of-service';
import { PrivacyPolicyPage } from '../pages/privacy-policy/privacy-policy';
import { AdFooter } from '../pages/ad-footer/ad-footer';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ApiService } from '../api-service/api-service';
import { InterceptorModule } from '../api-service/auth-interceptor.service';

import { FormdataUploadComponent } from '../formdata-upload/formdata-upload.component';

import { LazyLoadImageModule } from 'ng-lazyload-image';


import {GlobalAdCounter} from '../providers/global-ad-counter';

import {User, Cognito, DynamoDB, UserPost,UserData} from '../providers/providers';
import { Ladder } from '../providers/ladder';
//import { User } from '../providers/user';
//import { Cognito } from '../providers/aws.cognito';
//import { DynamoDB } from '../providers/aws.dynamodb';


@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    SignupPage,
    ConfirmPage,
    ForgotPwPage,
    SettingsPage,
    AboutPage,
    AccountPage,
    TabsPage,
    TasksPage,
    TasksCreatePage,
    HomePage,
    CategoryPage,
    PostPicPage,
    CommentViewPage,
    VoteBankPage,
    LeaderBoardPage,
    ChangePwPage,
    UserPostPage,
    PostFeedbackPage,
    TermsOfServicePage,
    PrivacyPolicyPage,
    AdFooter,
    FormdataUploadComponent
  ],
  imports: [
    BrowserModule,
    LazyLoadImageModule,
    HttpClientModule,
    IonicImageViewerModule,
    IonicModule.forRoot(MyApp),
    InterceptorModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    SignupPage,
    ConfirmPage,
    ForgotPwPage,
    SettingsPage,
    AboutPage,
    AccountPage,
    TabsPage,
    TasksPage,
    TasksCreatePage,
    HomePage,
    CategoryPage,
    PostPicPage,
    CommentViewPage,
    VoteBankPage,
    LeaderBoardPage,
    ChangePwPage,
    UserPostPage,
    PostFeedbackPage,
    TermsOfServicePage,
    PrivacyPolicyPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    FileTransfer,
    FileTransferObject,
    File,
    Camera,
    User,
    UserData,
    Cognito,
    DynamoDB,
    ApiService,
    SocialSharing,
    GlobalAdCounter,
    GoogleAnalytics
  ]
})
export class AppModule {}

declare var AWS;
AWS.config.customUserAgent = AWS.config.customUserAgent + ' Ionic';



// WEBPACK FOOTER //
// ./src/app/app.module.ts